module.exports = __webpack_public_path__ + "img/step_2-1.d2a30511.png";